module.exports = __webpack_public_path__ + "img/delete_icon.4b9e87b4.svg";